module.exports = __webpack_public_path__ + "static/media/idun16.f45c5683.JPG";